import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';

const fmtDate = (s) => {
  if (!s) return null;
  const d = new Date(/^\d{4}-\d{2}-\d{2}$/.test(s) ? `${s}T12:00:00` : s);
  return Number.isNaN(d.getTime()) ? s : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export default function SpecialPayoutCard({ stock }) {
  if (!stock?.special_only) return null;
  const payouts = (Array.isArray(stock.special_payouts) && stock.special_payouts.length
    ? stock.special_payouts
    : [{ amount: Number(stock.last_dividend_value), date: stock.last_dividend_date }]
  ).filter((p) => Number.isFinite(Number(p.amount)) && Number(p.amount) > 0);
  const multi = payouts.length > 1;
  return (
    <div className="mb-3 rounded-lg border border-amber-500/40 bg-amber-500/5 p-3" data-testid="special-payout-card">
      <div className="flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-amber-600 dark:text-amber-400">
        <Sparkles className="w-3.5 h-3.5" /> {multi ? `${payouts.length} one-time special payouts` : 'One-time special payout'}
      </div>
      {multi ? (
        <ul className="mt-1 text-sm text-foreground space-y-0.5" data-testid="special-payout-list">
          {payouts.map((p) => (
            <li key={`${p.date}-${p.amount}`} data-testid={`special-payout-${p.date}`}>
              <strong>${Number(p.amount).toFixed(2)} per share</strong>{fmtDate(p.date) ? <> on <strong>{fmtDate(p.date)}</strong></> : null}
            </li>
          ))}
        </ul>
      ) : null}
      <p className="mt-1 text-sm text-foreground" data-testid="special-payout-summary">
        {multi
          ? <>These are the only payouts on record — none recurring — so {stock.ticker} is classed as a non-dividend stock: no regular dividend, no yield, no payout ratio.</>
          : <>
            {payouts[0] ? <strong>${Number(payouts[0].amount).toFixed(2)} per share</strong> : 'A single special payment'}
            {payouts[0] && fmtDate(payouts[0].date) ? <> on <strong>{fmtDate(payouts[0].date)}</strong></> : null}. This is the only payout on record, so {stock.ticker} is classed as a
            non-dividend stock: no recurring dividend, no yield, no payout ratio.
          </>}
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        Special dividends are one-off cash returns, often after an asset sale or a buyout falling through. They are not a promise of
        future income. <Link to="/learn/special-dividends-in-cagr-math" className="ht-inline-link">How specials distort yield math →</Link>
      </p>
    </div>
  );
}
